import { ModuleRoutes } from '@kiplin/web-common/architecture-core';
import { loadLazyAppModuleGuard } from '@kiplin/web-common/dependency-injection';
import { UsageDataRouteName } from '@client/feature/usage-data/application/routes/usage-data.route-name';
import type { Container } from 'inversify';
import type { RouteRecordRaw } from 'vue-router';
import { checkCurrentClientUserHasClient } from '@client/common/router/application/routes/check-current-client-user-has-client.route-guard';
import { checkClientHasSubscription } from '@client/common/router/application/routes/check-client-has-subscription.route-guard';

const UsageDataAppModule = () => import('@client/feature/usage-data/usage-data.app-module');
const UsageDataPage = () => import('@client/feature/usage-data/application/page/UsageDataPage.vue');

export class UsageDataModuleRoutes extends ModuleRoutes<UsageDataRouteName> {
  constructor(container: Container) {
    const routes: RouteRecordRaw[] = [
      {
        path: 'usages',
        name: UsageDataRouteName.Dashboard,
        component: UsageDataPage,
        beforeEnter: [
          loadLazyAppModuleGuard(UsageDataAppModule, container),
          () => checkCurrentClientUserHasClient(),
          () => checkClientHasSubscription(),
        ],
      },
    ];

    super(routes);
  }
}
